import isEqual from 'lodash/isEqual';
import { atom, selector } from 'recoil';

export const isAmbientListeningActive = atom({
  key: 'isAmbientListeningActive',
  default: false
});

export const enhanceAmbientListeningLoading = atom({
  key: 'enhanceAmbientListeningLoading',
  default: false
});

export const ambientListeningIntelligenceChatId = atom({
  key: 'ambientListeningIntelligenceChatId',
  default: null
});

export const enhancedNote = atom({
  key: 'enhancedNote',
  default: null
});

export const ambientListeningMessages = atom({
  key: 'ambientListeningMessages',
  default: []
});

export const ambientListeningRegenerateTargetId = atom({
  key: 'ambientListeningRegenerateTargetId',
  default: null
});

export const isAmbientNoteEdited = atom({
  key: 'isAmbientNoteEdited',
  default: false
});

export const ambientListeningStreamingText = atom({
  key: 'ambientListeningStreamingText',
  default: null
});

export const emCPTsText = atom({
  key: 'emCPTsText',
  default: null
});

// True after an abort that produced nothing; cleared when a new generation starts.
export const ambientListeningStopped = atom({
  key: 'ambientListeningStopped',
  default: false
});

export const currentActiveStepID = atom({
  key: 'currentActiveStepID',
  default: 1
});

export const transcriptionLoading = atom({
  key: 'transcriptionLoading',
  default: false
});

export const isTranscriptionCreated = atom({
  key: 'isTranscriptionCreated',
  default: null
});

export const transcriptions = atom({
  key: 'transcriptions',
  default: []
});

export const selectedNoteType = atom({
  key: 'selectedAmbientListeningNoteType',
  default: null
});

export const preSelectedNoteType = atom({
  key: 'preSelectedAmbientListeningNoteType',
  default: null
});

export const additionalProviderNotesState = atom({
  key: 'additionalProviderNotesState',
  default: ''
});

export const transcriptEditingRowIdState = atom({
  key: 'transcriptEditingRowIdState',
  default: null
});

export const transcriptEditAllConversationsState = atom({
  key: 'transcriptEditAllConversationsState',
  default: false
});

export const transcriptStaticState = atom({
  key: 'transcriptStaticState',
  default: []
});

export const ambientListeningNoteTitle = atom({
  key: 'ambientListeningNoteTitle',
  default: ''
});

export const isTranscriptContentDirtyState = selector({
  key: 'isTranscriptContentDirtyState',
  get: ({ get }) => !isEqual(get(transcriptions), get(transcriptStaticState))
});

export const ambientListeningHasChipsState = atom({
  key: 'ambientListeningHasChipsState',
  default: false
});

export const isAmbientNoteEditingState = atom({
  key: 'isAmbientNoteEditingState',
  default: false
});
